const headers = {
  name: "Inventory request",
  navigate: {
    path: [
      {
        name: "Request",
        path: "/app/inventory/stock",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
